import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"
import { useDecision } from "@optimizely/react-sdk"
import Timeago from "../common/Timeago"
import { useAnswersCommentsQuery, useDeleteAnswersCommentMutation } from "./Answer.state"
import { CommentItem, CommentItemBody, CommentMeta, LoadingLine } from "./AnswerComments.style"
import { ConfirmationModal, Loadable, Pagination } from "../common"
import { Button } from "../App.styles"
import { useTeamDetailQuery } from '../teams/Teams.state'
import { ActionSpace } from './AnswerActions.style'
import { useState } from "react"

const TeamName = ({ id }) => {
    const { data, isFetching: isLoading } = useTeamDetailQuery(id)
    const teamName = data?.team?.name
    return isLoading && !teamName ? <LoadingLine /> : <strong className="d-block">{teamName}</strong>
}

const RenderCommentItem = ({ item, answerId, page }) => {
    const { t } = useTranslation()
    const { deleteComment, isDeletingComment } = useDeleteAnswersCommentMutation({ answerId, page })
    return (
        <CommentItem>
            <CommentItemBody>
                <TeamName id={item.team_id} />
                <span dangerouslySetInnerHTML={{__html: item.comment}} />
                <CommentMeta>
                    <span>{item.likes} {t(`likes`)}</span>
                    <ActionSpace direction="horizontal">
                        <Timeago.Display time={item.created_at} />
                    </ActionSpace>
                </CommentMeta>
            </CommentItemBody>
            <div>
                <ConfirmationModal
                    title={t("Confirm Deletion")}
                    body={t("Are you sure you wish to delete?")}
                    confirmLabel={t("Delete")}
                    confirmAction={() => deleteComment(item)}
                    isLoading={isDeletingComment}
                >
                    <Button color="danger" size="sm">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </ConfirmationModal>
            </div>
        </CommentItem>
    )
}

const PaginatedComments = ({ answerId }) => {
    const [page, setPage] = useState(1)

    // Fetch data from API using page and answerId
    const { data, isFetching } = useAnswersCommentsQuery({ answerId, page })
    const { pages, comments = [] } = data || {} // Destructure data and set default empty array for comments

    return (
        <Loadable loading={isFetching}>
            {
                comments.map(comment => (
                    <RenderCommentItem key={comment.id} item={comment} answerId={answerId} />
                ))
            }
            {
                pages > 0 && (
                    <Pagination
                        loading={isFetching}
                        page={page}
                        pages={pages}
                        setPage={setPage}
                    />
                )
            }
        </Loadable>
    )
}

const AnswerComments = ({ answerId }) => {
    const [decisionComments] = useDecision('comments')
    return (
        <div className="flex-grow-1 mb-4">
            {
                decisionComments?.enabled
                    ? <PaginatedComments answerId={answerId} />
                    : null
            }
        </div>
    )
}

export default AnswerComments